// src/pages/ComingSoon.js
import React from "react";

const ComingSoon = () => {
  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-[#0f1d38] text-white px-4">
      {/* Logo / Branding */}
      <div className="mb-12">
        <h1 className="text-4xl md:text-5xl font-bold text-[#1aa06a]">Lexora</h1>
      </div>

      {/* Main Heading */}
      <div className="text-center space-y-4 max-w-lg">
        <h2 className="text-3xl md:text-4xl font-bold">Something Exciting is <span className="text-[#1aa06a]">Coming soon!</span></h2>
        <p className="text-gray-300 text-lg">
          Stay tuned for updates and get ready to accelerate your business.
        </p>
      </div>

      

      {/* Notify Button */}
      <button className="mt-12 bg-[#1aa06a] text-white font-semibold px-8 py-3 rounded-full hover:bg-white hover:text-[#0f1d38] transition duration-300">
        Notify Me
      </button>

      {/* Footer Info */}
      <div className="mt-20 text-gray-400 text-sm text-center max-w-md">
        © 2024 Lexora S.L. All rights reserved.
      </div>
    </div>
  );
};

export default ComingSoon;